import { shape, string, node } from "prop-types"
import Icon from "components/planning_center_icon"

const HelperShelfMessage = props => {
  const { style } = props
  return (
    <div
      className="helper-shelf"
      data-helper-shelf="closed"
      id={`helper_shelf_${props.id}`}
      style={style}
    >
      <div className="helper-shelf__inner helper-container">
        <div className="helper-shelf__msg">{props.children}</div>
      </div>
    </div>
  )
}

const HelperShelfTrigger = props => {
  return (
    <button
      className={props.className ?? "icon"}
      data-helper-shelf-id={`helper_shelf_${props.id}`}
      aria-label="Toggle helper shelf"
      style={props.style}
      {...props}
    >
      <Icon symbol="general#outlined-info-circle" />
    </button>
  )
}

HelperShelfMessage.propTypes = {
  id: string,
  style: shape({}),
  children: node
}

HelperShelfTrigger.propTypes = {
  id: string,
  className: string,
  style: shape({})
}

export { HelperShelfMessage, HelperShelfTrigger }
